import React from 'react';
import ShoppingCartSummaryDiscountStyled from './bundle.esm2.js';
import { formatByCurrency } from '../../../utils/bundle.esm.js';
import { defaultFormatter } from '../bundle.esm3.js';

const ShoppingCartSummaryDiscount = (props) => {
  const { className, shoppingCartTotals, title } = props;
  const { formatter = defaultFormatter } = props;
  const { totalDiscounts } = shoppingCartTotals;
  if (totalDiscounts === null)
    return null;
  return /* @__PURE__ */ React.createElement(ShoppingCartSummaryDiscountStyled, {
    className: `ShoppingCartSummaryDiscount ShoppingCartItem ${className}`
  }, /* @__PURE__ */ React.createElement("p", {
    className: "ShoppingCartSummaryDiscount__title"
  }, title, ":"), /* @__PURE__ */ React.createElement("div", {
    className: "ShoppingCartSummaryDiscount__value"
  }, formatByCurrency(totalDiscounts, formatter)));
};
ShoppingCartSummaryDiscount.defaultProps = {
  className: "",
  title: "Descuentos",
  formatter: defaultFormatter
};

export { ShoppingCartSummaryDiscount as default };
//# sourceMappingURL=bundle.esm.js.map
